import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=21067566&scoped=true&"
import script from "./ProductCreate.vue?vue&type=script&lang=ts&"
export * from "./ProductCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21067566",
  null
  
)

export default component.exports